/** @jsxImportSource @emotion/react */
import Markdown from "react-markdown";
import { styleTextNova } from "./style";

type ChannelCartProps = {
  variant?:
    | "title"
    | "title2"
    | "title3"
    | "subtitle"
    | "subtitle2"
    | "subtitle3"
    | "label"
    | "text"
    | "helper"
    | "span"
    | "copyright";
  children: string;
};

const getComponents: any = (variant: string) => {
  return {
    p: (props: any) => {
      switch (variant) {
        case "title":
          return <h1 css={styleTextNova.title}>{props.children}</h1>;
        case "title3":
          return <h3 css={styleTextNova.title3}>{props.children}</h3>;
        case "subtitle3":
          return <p css={styleTextNova.subtitle3}>{props.children}</p>;
        case "span":
          return <span css={styleTextNova.text}>{props.children}</span>;
        case "label":
          return <span css={styleTextNova.label}>{props.children}</span>;
        case "copyright":
          return <p css={styleTextNova.copyright}>{props.children}</p>;
        default:
          return <p css={styleTextNova.text}>{props.children}</p>;
      }
    },
    a: (props: any) => (
      <a
        {...props}
        style={{ textDecoration: "underline" }}
        target="_blank"
        rel="noopener noreferrer"
      >
        {props.children}
      </a>
    )
  };
};

export const TextNova = ({ variant = "text", children }: ChannelCartProps) => {
  return <Markdown components={getComponents(variant)}>{children}</Markdown>;
};
